export const CHATBOT_SUGGESTED_QUESTIONS = [
  'chatbot.suggested.question.1',
  'chatbot.suggested.question.2',
  'chatbot.suggested.question.3',
];
